import { render } from "./TagSearch.vue?vue&type=template&id=60e6990c&scoped=true"
import script from "./TagSearch.vue?vue&type=script&lang=js"
export * from "./TagSearch.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./TagSearch.vue?vue&type=style&index=1&id=60e6990c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e6990c"]])

export default __exports__